import { createUseStyles } from 'react-jss'

export const style = {
  sideBySideChartFilterBar: {
    display: 'flex',
    width: '100%',
    margin: '12px 0',
    position: 'relative',
    '& > *': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '50%'
    }
  },
  noDataMessage: {
    margin: 'auto',
    textAlign: 'center',
    padding: '50px 0'
  },
  chart: {
    width: '50%',
    '&:first-child': {
      marginRight: 5
    },
    '&:last-child': {
      marginLeft: 5
    }
  }
}

export const useStyles = createUseStyles(style)
